// src/components/GuestTable.js
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

const ReceptionTable = ({
  invitees = [],
  handleEditClick,
  arr_name,
  arr_side,
  arr_id,
  load,
  errorMessage,
  setErrorMessage,
  openAlert,
  setOpenAlert,
}) => {
  // ダイアログの状態を管理
  //   const [editTableDialogOpen, setEditTableDialogOpen] = useState(false);
  //   const [selectedTable, setSelectedTable] = useState({
  //     arrangement_name: arr_name,
  //     side: arr_side,
  //   });

  const getSideText = (side) => {
    let label, color;

    switch (side) {
      case "groom":
        label = "新郎";
        color = "secondary";
        break;
      case "bride":
        label = "新婦";
        color = "primary";
        break;
      case "N":
        label = "未定義";
        color = "default";
        break;
      default:
        label = "";
        color = "default";
        break;
    }

    return <Chip label={label} color={color} size="small" />;
  };

  //   const getGenderText = (gender) => {
  //     switch (gender) {
  //       case "M":
  //         return "男";
  //       case "F":
  //         return "女";
  //       case "N":
  //         return "未定義";
  //       default:
  //         return ""; // 万が一のためのデフォルト
  //     }
  //   };

  //   const getWillChip = (will) => {
  //     let label, color;

  //     switch (will) {
  //       case "yet":
  //         label = "未確定";
  //         color = "default"; // デフォルトの色
  //         break;
  //       case "yes":
  //         label = "参加";
  //         color = "primary"; // 成功色
  //         break;
  //       case "no":
  //         label = "不参加";
  //         color = "secondary"; // エラー色
  //         break;
  //       default:
  //         label = "不明"; // 万が一のためのデフォルト
  //         color = "default";
  //     }

  //     return <Chip label={label} color={color} />;
  //   };

  const getIsAttendIcon = (is_attend) => {
    let label, color;

    switch (is_attend) {
      case "yet":
        return "";
      case "yes":
        return <TaskAltIcon color="success" />;
      case "no":
        return "";
      default:
        return "";
    }
  };

  const getInvitedByText = (
    invited_by,
    first_name,
    last_name,
    first_furigana,
    last_furigana
  ) => {
    let name, furigana;
    if (invited_by === "host") {
      name = "ホスト";
    } else {
      name = last_name + "　" + first_name;
      furigana = last_furigana + "　" + first_furigana;
    }

    return (
      <>
        {/* <Typography variant="body2" color="textSecondary">{furigana}</Typography> */}
        {name}
      </>
    );
  };

  const theme = useTheme();
  return (
    <>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
          {getSideText(arr_side)}
          <Typography variant="h6">{arr_name}</Typography>
        </Stack>
      </Stack>

      <TableContainer component={Paper} className="table-container">
        <Table aria-label="guest table">
          <TableHead>
            <TableRow>
              <TableCell className="sticky-col">呼び名</TableCell>
              <TableCell>苗字</TableCell>
              <TableCell>名前</TableCell>
              <TableCell>受付状況</TableCell>
              <TableCell>招待者</TableCell>
              {/* <TableCell>参加予定</TableCell> */}
              <TableCell>手動受付</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invitees.map((invitee) => (
              <TableRow key={invitee.id}>
                <TableCell className="sticky-col">
                  {invitee.nick_name}
                </TableCell>

                <TableCell>
                  <Typography variant="body2" color="textSecondary">
                    {invitee.last_furigana}
                  </Typography>
                  {invitee.last_name}
                </TableCell>
                <TableCell>
                  <div>
                    <Typography variant="body2" color="textSecondary">
                      {invitee.first_furigana}
                    </Typography>
                    {invitee.first_name}
                  </div>
                </TableCell>
                <TableCell>{getIsAttendIcon(invitee.is_attend)}</TableCell>
                <TableCell>
                  {getInvitedByText(
                    invitee.invited_by,
                    invitee.invited_by_first_name,
                    invitee.invited_by_last_name,
                    invitee.invited_by_first_furigana,
                    invitee.invited_by_last_furigana
                  )}
                </TableCell>
                {/* <TableCell>
                                <Stack direction="row" spacing={1}>
                                    {getWillChip(invitee.will)}
                                </Stack>
                            </TableCell> */}
                <TableCell>
                  <IconButton
                    onClick={() => handleEditClick(invitee)}
                    color="primary"
                    title="編集"
                  >
                    <ManageAccountsIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ReceptionTable;
